import { fetchUserMetadata } from "./thunkActions";

import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  error: null,
  loading: true,
  metadata: null,
};

export const ownUserSlice = createSlice({
  name: "ownUser",
  initialState,
  reducers: {
    resetUser: () => initialState,
    setFirebaseUserLoading: (state, action) => {
      state.loadingFirebaseUser = action.payload || false;
    },
    setFirestoreUserData: (state, action) => {
      state.firestoreUserData = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchUserMetadata.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchUserMetadata.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(fetchUserMetadata.fulfilled, (state, action) => {
        state.loading = false;
        state.metadata = action.payload?.metadata;
      });
  },
});

const { actions, reducer } = ownUserSlice;
const { resetUser } = actions;
export { reducer, resetUser };
